<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">仓库管理</div>
    <div class="item-space">
      <a-space
        :size="isMobile ? 20 : 100"
        :direction="isMobile ? 'vertical' : 'horizontal'"
      >
        <div class="df vertical">
          <div class="step-label">替代仪器</div>
          <a-input
            v-model:value="machineInfo.replaceSerial"
            style="width: 200px"
            placeholder="请输入替代仪器"
            @change="handleInputChange"
            :disabled="!isEdit"
          ></a-input>
        </div>

        <div class="df vertical">
          <div class="step-label">返厂时间</div>
          <select-day-vue
            :defaultVal="machineInfo.returnDate"
            style="width: 200px"
            @userDelectDay="userDelectDay"
            :disabled="!isEdit"
          ></select-day-vue>
        </div>
      </a-space>

      <div class="df item-space">
        <div class="step-label">返回附件(标配)</div>
        <div
          class="accessory standard"
          :class="[isMobile ? 'mobile-accessory' : '']"
          v-if="standardList.length > 0"
        >
          <template v-for="item in standardList" :key="item.searchVal">
            <div class="accessory-item">
              <div class="label">{{ item.label }}</div>
              <div class="val">{{ item.val }}</div>
            </div>
          </template>
        </div>
      </div>

      <div class="df item-space">
        <div class="step-label">返回附件(选配)</div>
        <div
          class="accessory optional"
          :class="[isMobile ? 'mobile-accessory' : '']"
          v-if="optionalList.length > 0"
        >
          <template v-for="item in optionalList" :key="item.searchVal">
            <div class="accessory-item">
              <div class="label">{{ item.label }}</div>
              <div class="val">{{ item.val }}</div>
            </div>
          </template>
        </div>
      </div>

      <div class="form-item">
        <a-space :size="isMobile ? 20 : 100" :direction="isMobile ? 'vertical' : 'horizontal'">
          <div class="df">
            <div class="step-label">完成时间</div>
            <div class="data">
              <select-day-vue
                :defaultVal="machineInfo.completeDate"
                @userDelectDay="userSelectDay"
                :disabled="!isEdit"
              ></select-day-vue>
            </div>
          </div>
          <div class="df">
            <div class="step-label">经手人</div>
            <div class="data">
              <a-input
                v-model:value="machineInfo.principal"
                placeholder="请输入经手人"
                allow-clear
                :disabled="!isEdit"
              ></a-input>
            </div>
          </div>

          <div class="df" v-if="machineInfo.username">
            <div class="step-label">编辑人</div>
            <div class="data" style="font-size: 16px">
              {{ machineInfo.username }}
            </div>
          </div>
        </a-space>
      </div>
      <div class="footer df both-side">
        <a-button @click="saveStepInfo" type="primary" :disabled="!isEdit"
          >保存</a-button
        >
        <a-button @click="nextStep" :disabled="!isEdit">下一步</a-button>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent, ref, reactive, computed, watch } from "vue";
import {
  saveOrUpdateRepairEquipment,
  saveOrUpdateSwanAccessory,
  saveOrUpdateColumbaAccessory,
  getSwanAccessoryByRepairEquipmentId,
  getColumbaAccessoryByRepairEquipmentId,
  warehouseConfirm,
} from "@/request/view/repair";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { Toast } from "@/utils";
import { getshowAccessoryByReq } from "@/views/repair/serve/getReqAccessory";
import { standardConfigOptions, optionalOptions } from "../serve/accessory";
import selectDayVue from "./selectDay.vue";
import { showModal } from "../serve/modal";

export default defineComponent({
  components: { selectDayVue },
  props: {
    machine: Object,
    meta: Object,
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const back = () => {
      // router.replace("/repairequipment");
      context.emit("back");
    };
    const machineInfo = reactive({
      id: null,
      type: null,
      accessoryId: null,
      returnDate: null,
      replaceSerial: null,
      repairProcess: null,
      principal: null,
      completeDate: null,
      userId: null,
      username: null,
    });

    const store = useStore();

    const isMobile = computed(() => store.state.isMonile);

    const getEditLock = () => {
      const { id, username } = store.state.user.user;
      if (machineInfo.userId === null && machineInfo.username === null) {
        return true;
      } else if (machineInfo.userId == id) {
        return true;
      }
      return false;
    };

    const isEdit = computed(() => {
      if (store.getters.user) {
        const unlock = getEditLock();
        return (
          props.meta["/warehousemanagementupdateInfo"] &&
          machineInfo.repairProcess == 0 &&
          unlock
        );
      }
      return false;
    });

    const standardList = ref([]);

    const optionalList = ref([]);

    const showStandardConfigOptions = computed(
      () => standardConfigOptions()[machineInfo.type]
    );

    const showOptionalOptions = computed(
      () => optionalOptions()[machineInfo.type]
    );
    // 回显选配标配数据
    const getRepairEquiment = () => {
      getshowAccessoryByReq(machineInfo.type, machineInfo.id)
        .then((res) => {
          // showStandardConfigOptions.value.filter((item) => )
          const standard = res.findList.filter((item) => {
            return showStandardConfigOptions.value.find(
              (find) => find.searchVal === item.searchVal && item.val > 0
            );
          });
          const optional = res.findList.filter((item) => {
            return showOptionalOptions.value.find(
              (find) => find.searchVal === item.searchVal && item.val > 0
            );
          });
          standardList.value.length = 0;
          optionalList.value.length = 0;
          standardList.value.push(...standard);
          optionalList.value.push(...optional);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    const inputObj = reactive({
      returnDate: null,
      replaceSerial: null,
    });
    const handleInputChange = (e) => {
      inputObj.replaceSerial = e.target.value;
    };
    const userDelectDay = (time) => {
      machineInfo.returnDate = time;
    };
    // 更换替换设备/设备返厂
    const updateMachine = (data) => {
      saveOrUpdateRepairEquipment({
        id: machineInfo.id,
        returnDate: machineInfo.returnDate,
        replaceSerial: machineInfo.replaceSerial,
        principal: machineInfo.principal,
        completeDate: machineInfo.completeDate,
        userId: store.state.user.user.id,
        username: store.state.user.user.username,
      })
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
          if (inputObj.returnDate) machineInfo.returnDate = inputObj.returnDate;
          if (inputObj.replaceSerial)
            machineInfo.replaceSerial = inputObj.replaceSerial;
        })
        .catch((err) => {
          console.log(res);
        });
    };
    // 获取选中的参数
    const getAccessory = (list, select) => {
      const reqObj = {};
      list.forEach((item) => {
        const isSelect = select.findIndex((name) => item.value === name) !== -1;
        if (isSelect) {
          reqObj[item.value] = 1;
        } else {
          reqObj[item.value] = 0;
        }
      });
      return reqObj;
    };
    // 保存配件
    const setAccessory = () => {
      const reqFn = {
        天鸽: saveOrUpdateColumbaAccessory,
        天鹅: saveOrUpdateSwanAccessory,
      };
      // 请求参数
      const standard = getAccessory(
        showStandardConfigOptions.value,
        standardList.value
      );
      const optional = getAccessory(
        showOptionalOptions.value,
        optionalList.value
      );
      // 合并标配和选配的请求参数
      const reqObj = Object.assign(standard, optional);
      reqObj.repairEquipmentId = machineInfo.id;

      if (machineInfo.accessoryId) {
        reqObj.id = machineInfo.accessoryId;
      }
      reqFn[machineInfo.type](reqObj)
        .then((res) => {
          Toast(res.code === 200 ? "success" : "warning", res.message, 3);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    // 保存信息
    const saveStepInfo = () => {
      // setAccessory();
      updateMachine();
    };

    const nextStep = () => {
      showModal({
        title: "提示",
        toastText: "请先保存信息再确认到下一步流程？",
        success: () => {
          warehouseConfirm({
            repairEquipmentId: machineInfo.id,
          })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200 && res.message === "成功") {
                context.emit("updateMachineInfo");
                context.emit("updateProcess", res.data);
                back();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const userSelectDay = (time) => {
      machineInfo.completeDate = time;
    };

    watch(
      () => route,
      (val) => {
        if (val.path === "/repairprogress") {
          machineInfo.id = props.machine.id;
          machineInfo.type = props.machine.type.replace(
            /[^\u4E00-\u9FA5]/g,
            ""
          );
          machineInfo.replaceSerial = props.machine.replaceSerial;
          machineInfo.returnDate = props.machine.returnDate;
          machineInfo.repairProcess = props.machine.repairProcess;
          machineInfo.principal = props.machine.principal;
          machineInfo.completeDate = props.machine.completeDate;
          machineInfo.userId = props.machine.userId;
          machineInfo.username = props.machine.username;
          getRepairEquiment();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      standardList,
      optionalList,
      showStandardConfigOptions,
      showOptionalOptions,
      inputObj,
      machineInfo,
      saveStepInfo,
      nextStep,
      handleInputChange,
      userDelectDay,
      userSelectDay,
      isEdit,
      isMobile,
    };
  },
});
</script>

<style lang="less" scoped>
.accessory {
  display: flex;
  flex-wrap: wrap;
  padding: 16px 0 0 16px;
  border-radius: 6px;
  border: 1px solid #d9dce4;
  .accessory-item {
    display: flex;
    align-items: center;
    // width: 200px;
    padding: 4px 8px;
    height: 30px;
    margin-right: 16px;
    margin-bottom: 16px;
  }
  .label {
    // width: 100px;
    margin-right: 12px;
  }
}
.standard:nth-child(n) > div {
  padding: 4px 8px;
  color: #087d74;
  background: #f0fffd;
  border-radius: 8px;
  border: 1px solid #8ae3d2;
}
.optional:nth-child(n) > div {
  padding: 4px 8px;
  color: #026cae;
  background: #f0fffd;
  border-radius: 8px;
  border: 1px solid #8abce3;
}
.mobile-accessory {
  .accessory-item {
    font-size: 18px;
    margin-bottom: 10px;
  }
}

.form-item {
  display: flex;
  margin: 16px 0;
  .label {
    font-size: 16px;
    font-weight: bold;
    color: #282e34;
    margin-right: 10px;
  }
  .input-data {
    width: 308px;
  }
  .upload-data {
    width: 800px;
  }
  .text-area-data {
    width: 600px;
  }
}
</style>
